// Keeps every [data-va-fs] free-shipping meter in sync with the cart (top bar, product page, cart popup, cart page).
// Listens to the theme's cart events AND watches every cart request (fetch / XHR to /cart/add|change|update|clear),
// because apps such as SparkLayer add to cart without firing the theme event.
(() => {
  if (window.vaFreeShipping) return;
  window.vaFreeShipping = true;

  const CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  const root = () => window.Shopify?.routes?.root || '/';

  const render = (cart) => {
    if (!cart || typeof cart.items_subtotal_price !== 'number') return;
    document.querySelectorAll('[data-va-fs]').forEach((el) => {
      const threshold = Number(el.dataset.threshold) || 8500;
      const subtotal = cart.items_subtotal_price;
      const left = Math.max(threshold - subtotal, 0);
      el.classList.toggle('is-empty', cart.item_count === 0);
      el.classList.toggle('is-unlocked', left === 0);
      const fill = el.querySelector('.va-fs__fill');
      if (fill) fill.style.width = `${Math.min((subtotal / threshold) * 100, 100)}%`;
      const out = el.querySelector('[data-va-fs-left]');
      if (out) {
        out.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: el.dataset.currency || cart.currency || 'USD' }).format(left / 100);
      }
    });
  };

  const nativeFetch = window.fetch.bind(window);
  let timer;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      nativeFetch(`${root()}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then((r) => r.json())
        .then(render)
        .catch(() => {});
    }, 150);
  };

  // fetch()
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const p = nativeFetch(input, init);
    if (CART_WRITE.test(url)) p.then(refresh, refresh);
    return p;
  };
  // XMLHttpRequest (jQuery-based apps)
  const open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (CART_WRITE.test(String(url))) this.addEventListener('loadend', refresh);
    return open.call(this, method, url, ...rest);
  };

  const hook = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    // Catch-all: whenever the header or bottom-bar cart count changes, the cart changed.
    const mo = new MutationObserver(refresh);
    document.querySelectorAll('#cart-icon-bubble, .va-bnav__count').forEach((n) =>
      mo.observe(n, { childList: true, subtree: true, characterData: true, attributes: true })
    );
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook);
  else hook();
  // Phones restore pages from cache and resume background tabs; re-check the cart when that happens.
  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refresh(); });
})();
